import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, Input, Row, Col, Space, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Select from "react-select";
import { set } from "date-fns";
import { colors } from "../../theme/colors";

const PuOrderProducts = (props) => {
  const { data, handleOrderProducts, numProds, ordTot, isEdit, isEditable } =
    props;
  const [productsData, setProductsData] = React.useState([]);
  // const [productOptions, setProductOptions] = React.useState([]);
  const [tissueOptions, setTissueOptions] = React.useState([]);
  const [oldData, setOldData] = React.useState([]);

  React.useEffect(() => {
    console.log("Order Props ", props);
    console.log("Product Data: ", data);
    // console.log("Product Columns: ", columns);
    setProductsData(data);
    let options = [];
    let tempData = [];
    data.map((product) => {
      const obj = {
        value: product.TissueID,
        label: product.TissueID,
        Cost: product.Price,
        Quantity: 1,
        isDisabled: false,
        // key: product.ID,
        ...product,
      };
      options.push(obj);
      tempData.push({
        ...product,
        Cost: product.Price,
      });
    });
    setOldData(tempData);
    console.log("Product Options: ", options);
    setTissueOptions(options);
    // setProductsColumns(columns);
  }, []);

  const [orderTotal, setOrderTotal] = React.useState(ordTot ? ordTot : 0);
  const [numberOfProducts, setNumberOfProducts] = React.useState(
    numProds ? numProds : 0
  );
  const [selectedData, setSelectedData] = useState([
    {
      key: 1,
      TissueID: "",
      ProductCode: "",
      ProductName: "",
      ProductTotal: "",
    },
  ]);
  const addRow = () => {
    const newKey = selectedData.length
      ? selectedData[selectedData.length - 1].key + 1
      : 1;
    const newRow = {
      key: newKey,
      TissueID: "",
      ProductCode: "",
      ProductName: "",
      ProductTotal: "",
    };
    setSelectedData([...selectedData, newRow]);
  };

  const deleteRow = (key) => {
    // on delete, enable the option in the dropdown
    const selectedProduct = selectedData.find((row) => row.key === key);
    const newOptions = tissueOptions.map((option) =>
      option.value === selectedProduct.TissueID
        ? { ...option, isDisabled: false }
        : option
    );
    setTissueOptions(newOptions);
    // let curQty = selectedData.find(row => row.key === key).Quantity;
    let curQty = 1;
    let curTotal = selectedData.find((row) => row.key === key).ProductTotal;
    setNumberOfProducts(Number(numberOfProducts) - Number(curQty));
    setOrderTotal(Number(orderTotal) - Number(curTotal));
    setSelectedData(selectedData.filter((row) => row.key !== key));
  };

  const handleSelectChange = (value, key) => {
    // console.log("Selected Value: ", value.value);
    const newData = selectedData.map((row) =>
      row.key === key
        ? {
            ...row,
            TissueID: value.value,
            ProductCode: value.ProductCode,
            ProductName: value.ProductName,
            ProductTotal: Number(value.Price).toString(),
          }
        : row
    );
    console.log("tissueOptions: ", tissueOptions);
    // disable this option from the dropdown
    let newOptions = [];
    if (newData.length === 1) {
      newOptions = tissueOptions.map((option) =>
        option.value === value.value
          ? { ...option, isDisabled: true }
          : { ...option, isDisabled: false }
      );
    } else {
      newOptions = tissueOptions.map((option) =>
        option.value === value.value ? { ...option, isDisabled: true } : option
      );
    }
    setTissueOptions(newOptions);
    setSelectedData(newData);
    // setOrderTotal(Number(orderTotal) + Number(value.Cost));
    // setNumberOfProducts(Number(numberOfProducts) + 1);
    let tempTotal = 0,
      nop = 0;
    for (let i = 0; i < newData.length; i++) {
      const selectedProduct = tissueOptions.find(
        (option) => option.value === newData[i].TissueID
      );
      console.log("Handle QTY Product Options: ", selectedProduct);
      newData[i].Price = selectedProduct.Price;
      newData[i].StandardPrice = selectedProduct.Price;
      newData[i].ProductID = selectedProduct.ProductID;
      newData[i].ID = selectedProduct.ProductID;
      newData[i].ManufacturerID = selectedProduct.ManufacturerID;
      tempTotal += Number(newData[i].ProductTotal);
      nop += 1;
    }
    setOrderTotal(Number(tempTotal));
    setNumberOfProducts(Number(nop));

    handleOrderProducts(
      newData,
      Number(orderTotal) + Number(value.Cost),
      Number(numberOfProducts) + 1
    );
  };

  const columns = [
    {
      title: "Tissue ID",
      dataIndex: "TissueID",
      width: "20%",
      render: (_, record) => (
        <Select
          value={{ label: record.TissueID, value: record.TissueID }}
          onChange={(value) => handleSelectChange(value, record.key)}
          style={{ width: "100%" }}
          options={tissueOptions}
          isDisabled={!isEditable}
        />
      ),
    },
    {
      title: "Product Code",
      dataIndex: "ProductCode",
      width: "20%",
      render: (_, record) => (
        <Input value={record.ProductCode} disabled={true} />
      ),
    },
    {
      title: "Product Name",
      dataIndex: "ProductName",
      width: "20%",
      render: (_, record) => (
        <Input
          value={record.ProductName}
          // onChange={e => handleInputChange(e, record.key, 'ProductName')}
          disabled={true}
        />
      ),
    },
    {
      title: "Product Total",
      dataIndex: "ProductTotal",
      width: "20%",
      render: (_, record) => (
        <Input
          value={record.ProductTotal}
          // onChange={e => handleInputChange(e, record.key, 'ProductTotal')}
          disabled={true}
        />
      ),
    },
    {
      title: "",
      dataIndex: "actions",
      width: "10%",
      render: (_, record) => (
        <Space>
          <Button
            type="danger"
            icon={isEditable ? <DeleteOutlined /> : <></>}
            onClick={() => deleteRow(record.key)}
            disabled={!isEditable}
          />
        </Space>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ style, ...restProps }) => (
        <th
          {...restProps}
          style={{
            ...style,
            backgroundColor: "#eee",
            color: "#000",
          }}
        />
      ),
    },
    body: {
      cell: ({ style, ...restProps }) => (
        <td
          {...restProps}
          style={{
            ...style,
            backgroundColor: "#eee",
            color: "#000",
          }}
        />
      ),
    },
  };

  return (
    <div>
      <>
        <Table
          columns={columns}
          dataSource={isEdit ? oldData : selectedData}
          pagination={false}
          components={components}
          rowKey="key"
          bordered={false}
        />
        {isEditable && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={addRow}
            style={{ marginTop: 16, background: colors["primaryColor"] }}
          >
            Add New Row
          </Button>
        )}
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}
        >
          <Col span={3}>
            <Form.Item label="Number of Products">
              <Input value={`${numberOfProducts}`} disabled={true} />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item label="Order Total">
              <Input value={`$${orderTotal}`} disabled={true} />
            </Form.Item>
          </Col>
        </Row>
      </>
    </div>
  );
};

export default PuOrderProducts;
